<mat-form-field>
  <mat-chip-list #chipList>
    <mat-chip *ngFor="let f of filterFields"
       (contextmenu)="onContextMenu($event, f)">
      {{f.label}}
    </mat-chip>
    <div style="visibility: hidden; position: fixed"
      [style.left]="contextMenuPosition.x"
      [style.top]="contextMenuPosition.y"
      [matMenuTriggerFor]="contextMenu">
    </div>
    <mat-menu #contextMenu="matMenu">
      <ng-template matMenuContent let-item="item" let-remove="remove" let-change="change">
        <button mat-menu-item (click)="editBlock(item)" [disabled]="!change">Изменить</button>
        <button mat-menu-item (click)="removeBlock(item)" [disabled]="!remove">Удалить</button>
      </ng-template>
    </mat-menu>
    <input placeholder="Фильтр"
           [matChipInputFor]="chipList"
           [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
           [matChipInputAddOnBlur]="true"
           (matChipInputTokenEnd)="add($event)">
    <mat-chip matSuffix [matMenuTriggerFor]="filterMenu">
      <mat-icon>add</mat-icon>
    </mat-chip>
  </mat-chip-list>
</mat-form-field>
<div class="error">{{ checkText }}</div>
<mat-menu #filterMenu="matMenu">
  <!--button mat-menu-item [matMenuTriggerFor]="typeBlockMenu">Блок</button-->
  <button mat-menu-item [disabled]="disabled.block" (click)="addFilterBlock('param')">Выборка по параметру</button>
  <button mat-menu-item [disabled]="disabled.block" (click)="addFilterBlock('country')">Выборка по странам</button>
  <button mat-menu-item [disabled]="disabled.block" (click)="addFilterBlock('ratings')">Выборка из рейтингов</button>
  <button mat-menu-item [disabled]="disabled.block" (click)="addFilterBlock('reference')">Выбор похожих вузов</button>
  <button mat-menu-item [disabled]="disabled.block" (click)="addFilterBlock('name')">Ручной выбор университетов</button>
  <button mat-menu-item [matMenuTriggerFor]="logicOpMenu">Логический оператор</button>
</mat-menu>
<mat-menu #logicOpMenu="matMenu">
  <button mat-menu-item [disabled]="disabled.operation" (click)="addFilterOp({v: 'AND', label: 'AND'})">AND</button>
  <button mat-menu-item [disabled]="disabled.operation" (click)="addFilterOp({v: 'OR', label: 'OR'})">OR</button>
  <button mat-menu-item [disabled]="disabled.not" (click)="addFilterOp({v: 'NOT', label: 'NOT'})">NOT</button>
  <button mat-menu-item [disabled]="disabled.openBracket" (click)="addFilterOp({v: '(', label: '('})">(</button>
  <button mat-menu-item [disabled]="disabled.closeBracket" (click)="addFilterOp({v: ')', label: ')'})">)</button>
</mat-menu>
